import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import { Router, withRouter, Switch, Route } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import AppRouter from '../containers/AppRouter';
import rootReducer from '../reducers';
import { logEvent } from '../helpers/analytics';
import 'normalize.css';
import 'animate.css';
// import 'material-components-web/dist/material-components-web.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'rc-tooltip/assets/bootstrap.css';
import '../styles/bootstrap.scss';
import '../styles/theme.scss';
import 'babel-polyfill';
import 'url-search-params-polyfill';

const configureStore = () => {
  const devTools =
    window.devToolsExtension && process.env.NODE_ENV !== 'production' ? window.devToolsExtension() : f => f;

  const store = createStore(rootReducer, compose(applyMiddleware(thunkMiddleware), devTools));

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};

export const store = configureStore();

const history = createHistory();

const render = () => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <Router history={history}>
          <Route component={AppRouter} />
        </Router>
      </Provider>
    </AppContainer>,
    document.getElementById('app')
  );
};

const closestA = el => {
  if (el.tagName.toLowerCase() === 'a') {
    return el;
  } else if (el.tagName.toLowerCase() === 'body') {
    return false;
  } else {
    return closestA(el.parentNode);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function(evt) {
    if (!evt.defaultPrevented) {
      const aEl = closestA(evt.target);
      if (aEl) {
        logEvent('ExternalLinkClicked', {
          href: aEl.href,
          source: aEl.dataset.source,
        });
      }
    }
  });

  render();

  if (module.hot) {
    module.hot.accept('../containers/AppRouter', () => {
      render();
    });
  }
});
